import React from "react";
import { Autocomplete, Checkbox, FormHelperText, TextField, createFilterOptions } from "@mui/material";
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { useQuery } from "@tanstack/react-query";
import publicService from "../../../service/publicService";

const filterOptions = createFilterOptions({
  limit: 50,
  stringify: (option) => `${option?.name} ${option?.code}`,
});

const getUnitLabel = (option) => (option?.code ? `${option?.name} (${option?.code})` : "");

const UnitOfMeasureSelect = ({ value, onChange, enabled = true, error, helperText, placeholder = "Select units of measurement" }) => {
  const quantityCodesQuery = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: ["quantity-codes"],
    queryFn: () => publicService.getQuantityCodes(),
  });

  const options = quantityCodesQuery?.data?.data?.data ?? [];

  return (
    <React.Fragment>
      <Autocomplete
        multiple
        disableCloseOnSelect
        limitTags={6}
        id="units-of-measure"
        options={options}
        value={value ?? []}
        loading={quantityCodesQuery.isPending}
        filterOptions={filterOptions}
        getOptionLabel={getUnitLabel}
        onChange={(e, selected) => onChange(selected)}
        isOptionEqualToValue={(option, selected) => option?.code === selected?.code}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={option?.code}>
            <Checkbox
              icon={<MdCheckBoxOutlineBlank size={20} />}
              checkedIcon={<MdCheckBox size={20} />}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {getUnitLabel(option)}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            variant="outlined"
            error={error}
            placeholder={quantityCodesQuery.isPending ? "Loading units..." : placeholder}
          />
        )}
      />
      {helperText ? <FormHelperText error={error}>{helperText}</FormHelperText> : null}
    </React.Fragment>
  );
};

export default UnitOfMeasureSelect;
